<template>
  <div>
		<!-- 头部 -->
    <headers :title="'请评价'"/>
    <!--  -->
		<div style="height: 40px;"></div>
    <div class="comment-wrap">
      <div class="comment-title">请对本次服务进行评价</div>
      <div class="menu-body">
        <div
          class="menu-item"
          v-for="(item, index) in commentList"
          :key="index"
          @click="selectMenu(index)"
        >
          <div class="menu-item-inner">
            <div class="menu-item-inner-inner">
              <van-image
                class="menu-item-inner-inner-img"
                width="100%"
                height="100%"
                fit="cover"
                :src="
                  currentIndex == index
                    ? require(`../../assets/img/comment/comment-select${
                        index + 1
                      }.png`)
                    : require(`../../assets/img/comment/comment${
                        index + 1
                      }.png`)
                "
              />
            </div>
          </div>
          <div
            :class="
              currentIndex == index
                ? 'menu-item-name menu-item-name-select'
                : 'menu-item-name'
            "
          >
            {{ item }}
          </div>
        </div>
      </div>
      <!-- 建议及意见 -->
      <div class="text-body">
				<div class="text-title">
					建议及意见
				</div>
        <el-input
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          placeholder=""
          v-model="Description"
        >
        </el-input>
      </div>
    </div>
    <!--  -->
    <!-- 底部按钮 -->
    <template>
      <div style="height: 80px"></div>
      <div class="footBtn">
        <div class="footBtn-item">
          <van-button
            type="info"
            square
            block
            :loading="submitLoading"
            :disabled="isSubmit"
            @click="confirm"
            >提交评价</van-button
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      OrderId: "",
      OpenId: "",
      commentList: ["满意", "一般", "不满意"], //满意，一般，不满意
      currentIndex: 0, //当前选择下标
      submitLoading: false,
      isSubmit: false,
			Description:"",
    };
  },
  created() {
    this.OrderId = this.$route.query.OrderId;
    this.OpenId = this.$route.query.OpenId;
  },
  mounted() {},
  methods: {
    selectMenu(index) {
      if (this.currentIndex != index) {
        this.currentIndex = index;
      } else {
        this.currentIndex = null;
      }
    },
    //提交
    confirm() {
      if (this.currentIndex == null) {
        Toast.fail("请评价");
        return;
      }
      this.submitLoading = true;
      this.$axios
        .post("/api/DjOrder/SaveComment", {
          OrderId: this.OrderId,
          CommentContent: this.commentList[this.currentIndex], // 评价：满意，一般，不满意
          OpenId: this.OpenId,
					Description:this.Description,
        })
        .then((res) => {
          this.submitLoading = false;
          this.isSubmit = true;
          let data = res.data;
          if (data.type == 1) {
            Toast.fail(data.message);
            setTimeout(() => {
              this.$router.replace("/");
            }, 1000);
          } else {
            Toast.fail(data.message);
          }
        });
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.comment-title{
  padding: 12px;
  box-sizing: border-box;
  font-size: 18px;
}
.menu-body {
  display: flex;
  flex-wrap: wrap;
  padding: 20px 30px;

  .menu-item {
    box-sizing: border-box;
    width: 33.33%;
    padding-bottom: 12px;

    .menu-item-inner {
      box-sizing: border-box;
      width: 100%;
      padding: 20px 20px 6px 20px;

      .menu-item-inner-inner {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        border-radius: 8px;
        background-color: #fff;
        color: #fff;
        position: relative;

        .menu-item-inner-inner-img {
          border-radius: 8px;
          overflow: hidden;
        }
      }
    }

    .menu-item-name {
      font-size: 16px;
      line-height: 1.4;
      text-align: center;
      color: #bebebe;
    }

    .menu-item-name-select {
      color: #333;
    }
  }
}
.text-body{
	padding: 12px;
	box-sizing: border-box;
	.text-title{
		font-size: 16px;
		line-height: 1.4;
		color: #333;
		padding: 4px 0px;
	}
}

.footBtn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  box-sizing: border-box;
  border-top: 1px solid #eeeeee;
  background: #ffffff;
  z-index: 1005;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  display: flex;

  .footBtn-item {
    flex: 1;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Comment/index.vue